import React, {Component} from 'react';
import './NavbarDrawer.css'
import NavbarDrawerDropdown from './NavbarDrawerDropdown.js'
import NavbarDrawerNonDropdown from './NavbarDrawerNonDropdown.js'
import {company_profile, company_industries, company_team, contact_us} from './NavbarLinks';


export default class NavbarDrawer extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		let drawerClasses = ['navbar_drawer'];

		if (this.props.show) {
			drawerClasses = ['navbar_drawer open']
		}

		return (
			<nav className={drawerClasses}>
				<ul className="navbar_drawer_list">
					<hr className="navbar_dropdown_hr"/>
					<li className="navbar_drawer_list_item"><NavbarDrawerDropdown headerTitle="ABOUT US" data={company_profile} click={this.props.drawerClickHandler}/></li>
					<li className="navbar_drawer_list_item"><NavbarDrawerDropdown headerTitle="INDUSTRIES" data={company_industries} click={this.props.drawerClickHandler}/></li>
					<li className="navbar_drawer_list_item"><NavbarDrawerDropdown headerTitle="KEY MEMBERS" data={company_team} click={this.props.drawerClickHandler} /></li>
					<li className="navbar_drawer_list_item"><NavbarDrawerDropdown headerTitle="CONTACT US" data={contact_us} click={this.props.drawerClickHandler} /></li>
				</ul>
			</nav>
		)
	}
};
